"use strict";
module.exports = validate20;
module.exports.default = validate20;
var schema22 = { "$schema": "http://json-schema.org/draft-07/schema#", "definitions": { "User": { "properties": { "identities": { "additionalProperties": { "type": "string" }, "type": "object" }, "segments": { "items": { "type": "string" }, "type": "array" }, "traits": { "additionalProperties": {}, "type": "object" } }, "required": ["identities"], "type": "object" } }, "properties": { "action": { "type": "string" }, "metadata": { "additionalProperties": { "anyOf": [{ "items": {}, "type": "array" }, { "type": ["string", "number", "boolean"] }] }, "properties": { "currency": { "type": "string" }, "market": { "type": "string" }, "orderId": { "type": "string" }, "price": { "type": "number" }, "quantity": { "type": "number" } }, "type": "object" }, "opposite": { "type": "boolean" }, "segments": { "items": { "type": "string" }, "type": "array" }, "sourceId": { "type": "string" }, "target": { "additionalProperties": { "type": "string" }, "type": "object" }, "timestamp": { "type": "string" }, "user": { "$ref": "#/definitions/User" } }, "required": ["action", "target"], "type": "object" };
var schema23 = { "properties": { "identities": { "additionalProperties": { "type": "string" }, "type": "object" }, "segments": { "items": { "type": "string" }, "type": "array" }, "traits": { "additionalProperties": {}, "type": "object" } }, "required": ["identities"], "type": "object" };
function validate20(data, valCxt) {
    "use strict";
    ;
    if (valCxt) {
        var instancePath = valCxt.instancePath;
        var parentData = valCxt.parentData;
        var parentDataProperty = valCxt.parentDataProperty;
        var rootData = valCxt.rootData;
    }
    else {
        var instancePath = "";
        var parentData = undefined;
        var parentDataProperty = undefined;
        var rootData = data;
    }
    var vErrors = null;
    var errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.action === undefined) {
            var err0 = { instancePath: instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "action" }, message: "must have required property '" + "action" + "'", schema: schema22.required, parentSchema: schema22, data: data };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.target === undefined) {
            var err1 = { instancePath: instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "target" }, message: "must have required property '" + "target" + "'", schema: schema22.required, parentSchema: schema22, data: data };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.action !== undefined) {
            var data0 = data.action;
            if (typeof data0 !== "string") {
                var err2 = { instancePath: instancePath + "/action", schemaPath: "#/properties/action/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.action.type, parentSchema: schema22.properties.action, data: data0 };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.metadata !== undefined) {
            var data1 = data.metadata;
            if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                for (var key0 in data1) {
                    if (!(((((key0 === "currency") || (key0 === "market")) || (key0 === "orderId")) || (key0 === "price")) || (key0 === "quantity"))) {
                        var data2 = data1[key0];
                        var _errs7 = errors;
                        var valid2 = false;
                        var _errs8 = errors;
                        if (!(Array.isArray(data2))) {
                            var err3 = { instancePath: instancePath + "/metadata/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/metadata/additionalProperties/anyOf/0/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema22.properties.metadata.additionalProperties.anyOf[0].type, parentSchema: schema22.properties.metadata.additionalProperties.anyOf[0], data: data2 };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                        var _valid0 = _errs8 === errors;
                        valid2 = valid2 || _valid0;
                        if (!valid2) {
                            var _errs10 = errors;
                            if (((typeof data2 !== "string") && (!((typeof data2 == "number") && (isFinite(data2))))) && (typeof data2 !== "boolean")) {
                                var err4 = { instancePath: instancePath + "/metadata/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/metadata/additionalProperties/anyOf/1/type", keyword: "type", params: { type: schema22.properties.metadata.additionalProperties.anyOf[1].type }, message: "must be string,number,boolean", schema: schema22.properties.metadata.additionalProperties.anyOf[1].type, parentSchema: schema22.properties.metadata.additionalProperties.anyOf[1], data: data2 };
                                if (vErrors === null) {
                                    vErrors = [err4];
                                }
                                else {
                                    vErrors.push(err4);
                                }
                                errors++;
                            }
                            var _valid0 = _errs10 === errors;
                            valid2 = valid2 || _valid0;
                        }
                        if (!valid2) {
                            var err5 = { instancePath: instancePath + "/metadata/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/metadata/additionalProperties/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf", schema: schema22.properties.metadata.additionalProperties.anyOf, parentSchema: schema22.properties.metadata.additionalProperties, data: data2 };
                            if (vErrors === null) {
                                vErrors = [err5];
                            }
                            else {
                                vErrors.push(err5);
                            }
                            errors++;
                        }
                        else {
                            errors = _errs7;
                            if (vErrors !== null) {
                                if (_errs7) {
                                    vErrors.length = _errs7;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                    }
                }
                if (data1.currency !== undefined) {
                    var data3 = data1.currency;
                    if (typeof data3 !== "string") {
                        var err6 = { instancePath: instancePath + "/metadata/currency", schemaPath: "#/properties/metadata/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.metadata.properties.currency.type, parentSchema: schema22.properties.metadata.properties.currency, data: data3 };
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                    }
                }
                if (data1.market !== undefined) {
                    var data4 = data1.market;
                    if (typeof data4 !== "string") {
                        var err7 = { instancePath: instancePath + "/metadata/market", schemaPath: "#/properties/metadata/properties/market/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.metadata.properties.market.type, parentSchema: schema22.properties.metadata.properties.market, data: data4 };
                        if (vErrors === null) {
                            vErrors = [err7];
                        }
                        else {
                            vErrors.push(err7);
                        }
                        errors++;
                    }
                }
                if (data1.orderId !== undefined) {
                    var data5 = data1.orderId;
                    if (typeof data5 !== "string") {
                        var err8 = { instancePath: instancePath + "/metadata/orderId", schemaPath: "#/properties/metadata/properties/orderId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.metadata.properties.orderId.type, parentSchema: schema22.properties.metadata.properties.orderId, data: data5 };
                        if (vErrors === null) {
                            vErrors = [err8];
                        }
                        else {
                            vErrors.push(err8);
                        }
                        errors++;
                    }
                }
                if (data1.price !== undefined) {
                    var data6 = data1.price;
                    if (!((typeof data6 == "number") && (isFinite(data6)))) {
                        var err9 = { instancePath: instancePath + "/metadata/price", schemaPath: "#/properties/metadata/properties/price/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema22.properties.metadata.properties.price.type, parentSchema: schema22.properties.metadata.properties.price, data: data6 };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
                if (data1.quantity !== undefined) {
                    var data7 = data1.quantity;
                    if (!((typeof data7 == "number") && (isFinite(data7)))) {
                        var err10 = { instancePath: instancePath + "/metadata/quantity", schemaPath: "#/properties/metadata/properties/quantity/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema22.properties.metadata.properties.quantity.type, parentSchema: schema22.properties.metadata.properties.quantity, data: data7 };
                        if (vErrors === null) {
                            vErrors = [err10];
                        }
                        else {
                            vErrors.push(err10);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err11 = { instancePath: instancePath + "/metadata", schemaPath: "#/properties/metadata/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.properties.metadata.type, parentSchema: schema22.properties.metadata, data: data1 };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
        }
        if (data.opposite !== undefined) {
            var data8 = data.opposite;
            if (typeof data8 !== "boolean") {
                var err12 = { instancePath: instancePath + "/opposite", schemaPath: "#/properties/opposite/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema22.properties.opposite.type, parentSchema: schema22.properties.opposite, data: data8 };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
        }
        if (data.segments !== undefined) {
            var data9 = data.segments;
            if (Array.isArray(data9)) {
                var len0 = data9.length;
                for (var i0 = 0; i0 < len0; i0++) {
                    var data10 = data9[i0];
                    if (typeof data10 !== "string") {
                        var err13 = { instancePath: instancePath + "/segments/" + i0, schemaPath: "#/properties/segments/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.segments.items.type, parentSchema: schema22.properties.segments.items, data: data10 };
                        if (vErrors === null) {
                            vErrors = [err13];
                        }
                        else {
                            vErrors.push(err13);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err14 = { instancePath: instancePath + "/segments", schemaPath: "#/properties/segments/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema22.properties.segments.type, parentSchema: schema22.properties.segments, data: data9 };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
        }
        if (data.sourceId !== undefined) {
            var data11 = data.sourceId;
            if (typeof data11 !== "string") {
                var err15 = { instancePath: instancePath + "/sourceId", schemaPath: "#/properties/sourceId/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.sourceId.type, parentSchema: schema22.properties.sourceId, data: data11 };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
        }
        if (data.target !== undefined) {
            var data12 = data.target;
            if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                for (var key1 in data12) {
                    var data13 = data12[key1];
                    if (typeof data13 !== "string") {
                        var err16 = { instancePath: instancePath + "/target/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/properties/target/additionalProperties/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.target.additionalProperties.type, parentSchema: schema22.properties.target.additionalProperties, data: data13 };
                        if (vErrors === null) {
                            vErrors = [err16];
                        }
                        else {
                            vErrors.push(err16);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err17 = { instancePath: instancePath + "/target", schemaPath: "#/properties/target/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.properties.target.type, parentSchema: schema22.properties.target, data: data12 };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
        }
        if (data.timestamp !== undefined) {
            var data14 = data.timestamp;
            if (typeof data14 !== "string") {
                var err18 = { instancePath: instancePath + "/timestamp", schemaPath: "#/properties/timestamp/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.timestamp.type, parentSchema: schema22.properties.timestamp, data: data14 };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
        }
        if (data.user !== undefined) {
            var data15 = data.user;
            if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                if (data15.identities === undefined) {
                    var err19 = { instancePath: instancePath + "/user", schemaPath: "#/definitions/User/required", keyword: "required", params: { missingProperty: "identities" }, message: "must have required property '" + "identities" + "'", schema: schema23.required, parentSchema: schema23, data: data15 };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
                if (data15.identities !== undefined) {
                    var data16 = data15.identities;
                    if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                        for (var key2 in data16) {
                            var data17 = data16[key2];
                            if (typeof data17 !== "string") {
                                var err20 = { instancePath: instancePath + "/user/identities/" + key2.replace(/~/g, "~0").replace(/\//g, "~1"), schemaPath: "#/definitions/User/properties/identities/additionalProperties/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema23.properties.identities.additionalProperties.type, parentSchema: schema23.properties.identities.additionalProperties, data: data17 };
                                if (vErrors === null) {
                                    vErrors = [err20];
                                }
                                else {
                                    vErrors.push(err20);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        var err21 = { instancePath: instancePath + "/user/identities", schemaPath: "#/definitions/User/properties/identities/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema23.properties.identities.type, parentSchema: schema23.properties.identities, data: data16 };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
                if (data15.segments !== undefined) {
                    var data18 = data15.segments;
                    if (Array.isArray(data18)) {
                        var len1 = data18.length;
                        for (var i1 = 0; i1 < len1; i1++) {
                            var data19 = data18[i1];
                            if (typeof data19 !== "string") {
                                var err22 = { instancePath: instancePath + "/user/segments/" + i1, schemaPath: "#/definitions/User/properties/segments/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema23.properties.segments.items.type, parentSchema: schema23.properties.segments.items, data: data19 };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        var err23 = { instancePath: instancePath + "/user/segments", schemaPath: "#/definitions/User/properties/segments/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema23.properties.segments.type, parentSchema: schema23.properties.segments, data: data18 };
                        if (vErrors === null) {
                            vErrors = [err23];
                        }
                        else {
                            vErrors.push(err23);
                        }
                        errors++;
                    }
                }
                if (data15.traits !== undefined) {
                    var data20 = data15.traits;
                    if (data20 && typeof data20 == "object" && !Array.isArray(data20)) { }
                    else {
                        var err24 = { instancePath: instancePath + "/user/traits", schemaPath: "#/definitions/User/properties/traits/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema23.properties.traits.type, parentSchema: schema23.properties.traits, data: data20 };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err25 = { instancePath: instancePath + "/user", schemaPath: "#/definitions/User/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema23.type, parentSchema: schema23, data: data15 };
                if (vErrors === null) {
                    vErrors = [err25];
                }
                else {
                    vErrors.push(err25);
                }
                errors++;
            }
        }
    }
    else {
        var err26 = { instancePath: instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.type, parentSchema: schema22, data: data };
        if (vErrors === null) {
            vErrors = [err26];
        }
        else {
            vErrors.push(err26);
        }
        errors++;
    }
    validate20.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validateSchema.js.map